import { render, staticRenderFns } from "./user-company-relations.vue?vue&type=template&id=4956298a&scoped=true"
import script from "./user-company-relations.vue?vue&type=script&lang=js"
export * from "./user-company-relations.vue?vue&type=script&lang=js"
import style0 from "./user-company-relations.vue?vue&type=style&index=0&id=4956298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956298a",
  null
  
)

export default component.exports